import { PRODUCT_TYPE } from "../../../../utils/constants";

export const PAGE_SIZE = 10;

export const SELECT_ALL_OPTIONS = {
  keyTopics: { value: "*", label: "-- Select All Key Topics --" },
  productType: { value: "*", label: "-- Select All Product Types --" },
  stakeHolder: { value: "*", label: "-- Select All StakeHolders --" },
  protagonist: { value: "*", label: "-- Select All Protagonist --" },
  standard: { value: "*", label: "-- Select All PSEL Standards --" },
  nelpStandard: { value: "*", label: "-- Select All NELP Standards --" },
  intascStandard: { value: "*", label: "-- Select All InTasc Standards --" },
  caepStandard: { value: "*", label: "-- Select All CAEP Standards --" },
  aaqepStandard: { value: "*", label: "-- Select All AAQEP Standards --" },
  naceStandard: { value: "*", label: "-- Select All NACE Standards --" },
  mceeStandard: { value: "*", label: "-- Select All MCEE Standards --" },
};

/** Maps sidebar filter key → API endpoint + criteria field */
export const FILTER_META = {
  keyTopics: {
    label: "Key Topics",
    placeholder: "Key Topics...",
    endpoint: "keyTopics/getAll",
    criteriaKey: "keyTopic",
  },
  productType: {
    label: "Audience Type",
    placeholder: "Audience Type...",
    endpoint: "productType/getAll",
    criteriaKey: "productTypes",
    transform: (data) =>
      data.filter(
        (item) =>
          item.label !== PRODUCT_TYPE.OTHERS &&
          item.label !== PRODUCT_TYPE.SMALL_DISTRICT,
      ),
  },
  stakeHolder: {
    label: "StakeHolder",
    placeholder: "StakeHolder...",
    endpoint: "stakeholders/getAll",
    criteriaKey: "stakeholders",
  },
  protagonist: {
    label: "Protagonist",
    placeholder: "Protagonist...",
    endpoint: "protagonists/getAll",
    criteriaKey: "protagonists",
  },
  standard: {
    label: "PSEL Standard",
    placeholder: "PSEL Standard...",
    endpoint: "standards/getAll",
    criteriaKey: "pselStandards",
  },
  nelpStandard: {
    label: "NELP Standard",
    placeholder: "NELP Standard...",
    endpoint: "nelpStandards/getAll",
    criteriaKey: "nelpStandards",
  },
  intascStandard: {
    label: "InTasc Standard",
    placeholder: "InTasc Standard...",
    endpoint: "intascStandards/getAll",
    criteriaKey: "intascStandards",
  },
  caepStandard: {
    label: "CAEP Standard",
    placeholder: "CAEP Standard...",
    endpoint: "caepStandards/getAll",
    criteriaKey: "caepStandards",
  },
  aaqepStandard: {
    label: "AAQEP Standard",
    placeholder: "AAQEP Standard...",
    endpoint: "aaqepStandard/getAll",
    criteriaKey: "aaqepStandards",
  },
  naceStandard: {
    label: "NACE Standard",
    placeholder: "NACE Standard...",
    endpoint: "naceStandard/getAll",
    criteriaKey: "naceStandards",
  },
  mceeStandard: {
    label: "MCEE Standard",
    placeholder: "MCEE Standard...",
    endpoint: "mceeStandard/getAll",
    criteriaKey: "mceeStandards",
  },
};

export const ALL_FILTER_KEYS = Object.keys(FILTER_META);

export const BASIC_FILTER_KEYS = [
  "stakeHolder",
  "protagonist",
  "standard",
  "nelpStandard",
];

export const emptySelectedFilters = (keys = ALL_FILTER_KEYS) =>
  keys.reduce((acc, key) => ({ ...acc, [key]: [] }), {});

export const buildCriteria = ({
  filterKeys,
  selectedFilters,
  searchTerm = "",
  showLastTwelveMonths = false,
  account = 0,
}) => {
  const criteria = {
    account,
    search: searchTerm.trim(),
    showLastTwelveMonths,
  };

  filterKeys.forEach((key) => {
    const { criteriaKey } = FILTER_META[key];
    criteria[criteriaKey] = selectedFilters[key] ?? [];
  });

  return criteria;
};
